(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boat-rs-contact-codex-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRs2Contact = (section) => {
      if (!section || section.dataset.rs2Initialized === 'true') return;
      const wrapper = section.closest('.shopify-section') || section.parentElement;
      const dialog = wrapper.querySelector('[data-rs2-contact-dialog]');
      if (!dialog) return;
      const closeButton = dialog.querySelector('[data-rs2-contact-close]');
      const statePanel = dialog.querySelector('[data-rs2-contact-states]');
      const actionPanel = dialog.querySelector('[data-rs2-contact-actions]');
      const selectedState = dialog.querySelector('[data-rs2-selected-state]');
      const callLink = dialog.querySelector('[data-rs2-call]');
      const textLink = dialog.querySelector('[data-rs2-text]');
      const backButton = dialog.querySelector('[data-rs2-contact-back]');
      let returnFocus = null;

      const resetDialog = () => {
        statePanel.hidden = false;
        actionPanel.hidden = true;
        selectedState.textContent = '';
        callLink.removeAttribute('href');
        textLink.removeAttribute('href');
      };

      document.querySelectorAll('[data-rs-v2-contact-open]').forEach((opener) => {
        if (opener.dataset.rs2Bound === 'true') return;
        opener.dataset.rs2Bound = 'true';
        opener.addEventListener('click', () => {
          returnFocus = opener;
          resetDialog();
          dialog.showModal();
          closeButton.focus();
        });
      });

      dialog.querySelectorAll('[data-rs2-contact-state]').forEach((button) => {
        button.addEventListener('click', () => {
          const state = button.dataset.state;
          const phone = button.dataset.phone;
          selectedState.textContent = `${state} team`;
          callLink.href = `tel:${phone}`;
          textLink.href = `sms:${phone}`;
          statePanel.hidden = true;
          actionPanel.hidden = false;
          callLink.focus();
        });
      });

      backButton.addEventListener('click', () => {
        resetDialog();
        const firstState = dialog.querySelector('[data-rs2-contact-state]');
        if (firstState) firstState.focus();
      });

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        resetDialog();
        if (returnFocus) returnFocus.focus();
      });
      section.dataset.rs2Initialized = 'true';
    };

    document.querySelectorAll('[data-rs2-contact-section]').forEach(initializeRs2Contact);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-rs2-contact-section]')
        ? event.target
        : event.target.querySelector('[data-rs2-contact-section]');
      initializeRs2Contact(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boat-rs-series-codex"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initRSPage(root) {
      if (!root || root.getAttribute('data-rs-ready') === 'true') return;
      root.setAttribute('data-rs-ready', 'true');

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        root.classList.add('rs-motion-ready');
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
        root.querySelectorAll('[data-rs-reveal]').forEach(function(element) {
          observer.observe(element);
        });
      }

      var modal = root.querySelector('[data-rs-contact-modal]');
      var openers = root.querySelectorAll('[data-rs-contact-open]');
      var closeButton = root.querySelector('[data-rs-contact-close]');
      var backButton = root.querySelector('[data-rs-contact-back]');
      var statesPanel = root.querySelector('[data-rs-contact-states]');
      var actionsPanel = root.querySelector('[data-rs-contact-actions]');
      var stateLabel = root.querySelector('[data-rs-selected-state]');
      var callLink = root.querySelector('[data-rs-call]');
      var textLink = root.querySelector('[data-rs-text]');
      var selectedState = '';
      var selectedPhone = '';

      function publish(name, extra) {
        try {
          var data = {
            button: 'Call or Text BoardCo',
            condition: 'new',
            product_title: 'Centurion RS Series',
            product_url: window.location.href
          };
          Object.keys(extra || {}).forEach(function(key) { data[key] = extra[key]; });
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish(name, data);
          }
        } catch (error) {}
      }

      function resetContact() {
        selectedState = '';
        selectedPhone = '';
        if (statesPanel) statesPanel.hidden = false;
        if (actionsPanel) actionsPanel.hidden = true;
        if (callLink) callLink.href = '#';
        if (textLink) textLink.href = '#';
      }

      openers.forEach(function(opener) {
        opener.addEventListener('click', function() {
          resetContact();
          if (modal && !modal.open) modal.showModal();
          publish('boardco:button_click', {});
        });
      });

      root.querySelectorAll('[data-rs-state]').forEach(function(button) {
        button.addEventListener('click', function() {
          selectedState = button.getAttribute('data-state');
          selectedPhone = button.getAttribute('data-phone');
          if (stateLabel) stateLabel.textContent = selectedState;
          if (callLink) callLink.href = 'tel:' + selectedPhone;
          if (textLink) textLink.href = 'sms:' + selectedPhone;
          if (statesPanel) statesPanel.hidden = true;
          if (actionsPanel) actionsPanel.hidden = false;
          publish('boardco:state_selected', {
            state: selectedState,
            form_url: 'tel:' + selectedPhone,
            phone: selectedPhone
          });
          if (callLink) callLink.focus();
        });
      });

      if (callLink) {
        callLink.addEventListener('click', function() {
          publish('boardco:contact_click', {
            method: 'call',
            state: selectedState,
            form_url: 'tel:' + selectedPhone,
            phone: selectedPhone
          });
        });
      }

      if (textLink) {
        textLink.addEventListener('click', function() {
          publish('boardco:contact_click', {
            method: 'text',
            state: selectedState,
            form_url: 'sms:' + selectedPhone,
            phone: selectedPhone
          });
        });
      }

      if (backButton) {
        backButton.addEventListener('click', function() {
          resetContact();
          var firstState = root.querySelector('[data-rs-state]');
          if (firstState) firstState.focus();
        });
      }
      if (closeButton) closeButton.addEventListener('click', function() { modal.close(); });
      if (modal) {
        modal.addEventListener('click', function(event) {
          if (event.target === modal) modal.close();
        });
        modal.addEventListener('close', resetContact);
      }
    }

    function setupRSPages() {
      document.querySelectorAll('[data-rs-codex-section]').forEach(initRSPage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupRSPages);
    } else {
      setupRSPages();
    }
    document.addEventListener('shopify:section:load', setupRSPages);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
